import React, { FC } from 'react'
import { Link } from 'react-router-dom'

import { LANDING } from '../../../constants/routes'
import { NavLogoIcon, CloseIcon } from '../../../components/Icons'

import { NavWrap, LogoWrap, LinksWrap } from './styled'

export const NavBar: FC = () => {
  return (
    <NavWrap>
      <LogoWrap>
        <Link to={LANDING}>
          <NavLogoIcon />
        </Link>
      </LogoWrap>
      <LinksWrap>
        <Link to={LANDING}>
          <CloseIcon />
        </Link>
      </LinksWrap>
    </NavWrap>
  )
}
